export interface AlainAuthConfig {
  /**
   * å­å¨KEYå¼ï¼é»è®¤ï¼`_token`
   */
  store_key?: string;
  /**
   * æ ææ¶è·³è½¬è³ç»å½é¡µï¼é»è®¤ï¼`true`ï¼åæ¬ï¼
   * - æ ætokenå¼
   * - tokenå·²è¿æï¼éJWTï¼
   */
  token_invalid_redirect?: boolean;
  /**
   * tokenè¿ææ¶é´åç§»å¼ï¼é»è®¤ï¼`10` ç§ï¼åä½ï¼ç§ï¼
   */
  token_exp_offset?: number;
  /**
   * åétokenåæ°åï¼é»è®¤ï¼Â·
   */
  token_send_key?: string;
  /**
   * åétokenæ¨¡æ¿ï¼é»è®¤ä¸ºï¼`'${token}'`ï¼ï¼ä½¿ç¨ `${token}` è¡¨ç¤ºtokenç¹ä½ç¬¦ï¼**æ³¨æï¼**è¯·å¡å¿ä½¿ç¨ \`\` åè£¹ï¼ï¼ä¾å¦ï¼
   *
   * - `Bearer ${token}`
   */
  token_send_template?: string;
  /**
   * åétokenåæ°ä½ç½®ï¼é»è®¤ï¼`header`
   */
  token_send_place?: 'header' | 'body' | 'url';
  /**
   * ç»å½é¡µè·¯ç±å°åï¼é»è®¤ï¼`/login`
   */
  login_url?: string;
  /**
   * å¿½ç¥TOKENçURLå°ååè¡¨ï¼é»è®¤å¼ä¸ºï¼`[/\/login/, /assets\//, /passport\//]`
   */
  ignores?: RegExp[];
  /**
   * åè®¸å¿åç»å½KEYï¼è¥è¯·æ±åæ°ä¸­å¸¦æè¯¥KEYè¡¨ç¤ºå¿½ç¥TOKENï¼é»è®¤ï¼`_allow_anonymous`
   */
  allow_anonymous_key?: string;
  /**
   * æ¯å¦æ ¡éªå¤±ææ¶å½ä¸­åç»§ç»­è°ç¨åç»­æ¦æªå¨ç `intercept` æ¹æ³ï¼é»è®¤ï¼`true`
   */
  executeOtherInterceptors?: boolean;
}
